import React from 'react';
import PropTypes from 'prop-types';

import { GTMServices } from '@services/gtm';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import * as S from './styles';

import circleBanner from '../../../../../assets/images/circle-banner.svg';
import circleBannerSecondary from '../../../../../assets/images/circle-banner-secondary.svg';
import circleBannerInverse from '../../../../../assets/images/circle-banner-inverse.svg';

const BonusJourney = ({ currentContent, isAcceptTerm }) => {
  const GTM_PROPS = {
    accepted: ['Jornada Bônus - 2024', 'Processos', 'Banner Aceite Clique'],
    eligible: ['Jornada Bônus - 2024', 'Processos', 'Banner Elegível Clique']
  };
  const {
    columnsWidths,
    backgroundColor,
    circleBackground,
    content
  } = currentContent;

  const renderCircleBackgroundBanner = () => {
    if (!circleBackground) return null;
    const { show, left, top, rotate, invert, type } = circleBackground;
    if (!show) return null;
    const circleBannerType = {
      default: circleBanner,
      secondary: circleBannerSecondary,
      inverse: circleBannerInverse
    };
    return (
      <S.BackgroundImage
        src={circleBannerType[type]}
        left={left}
        top={top}
        rotate={rotate}
        invert={invert}
        data-testid="circle-banner"
        alt="Circulo utilizado como fundo do banner"
      />
    );
  };

  const updateTextWithBoldWords = (text, boldWords) => {
    let boldWordsIndex = 0;

    return text.split(' ').map(item => {
      let updatedText;

      if (item === '%STRONG%' && boldWords) {
        updatedText = <strong>{`${boldWords[boldWordsIndex]} `}</strong>;
        boldWordsIndex += 1;
      } else {
        updatedText = `${item} `;
      }

      return updatedText;
    });
  };

  const handleRedirect = redirect => {
    const url = redirect.internal
      ? getSessionItem(redirect.internal)
      : redirect.external;

    const gtmProps = isAcceptTerm ? GTM_PROPS.accepted : GTM_PROPS.eligible;
    GTMServices.dispatchGtm(...gtmProps);

    window.open(url, redirect.target);
  };

  const renderCollumn = (collumn, collumnIndex) => {
    return (
      <S.Collumn key={collumnIndex}>
        {collumn.map((item, index) => {
          const Component = S[item.name];
          const params = {
            ...item,
            ...(item.redirect && {
              onClick: () => handleRedirect(item.redirect)
            })
          };
          const updatedText =
            item.boldWords && item.boldWords.length > 0
              ? updateTextWithBoldWords(item.children, item.boldWords)
              : item.children;

          return item.children ? (
            <Component key={`${item.name}-${index}`} {...params}>
              {updatedText}
            </Component>
          ) : (
            <Component key={`${item.name}-${index}`} {...params} />
          );
        })}
      </S.Collumn>
    );
  };

  return (
    <S.Wrapper
      columnsWidths={columnsWidths}
      backgroundColor={backgroundColor}
      data-testid="banner-bonus-journey"
    >
      {renderCircleBackgroundBanner()}
      {content.map((collumn, index) => renderCollumn(collumn, index))}
    </S.Wrapper>
  );
};

export default BonusJourney;

BonusJourney.propTypes = {
  currentContent: PropTypes.object.isRequired,
  isAcceptTerm: PropTypes.bool.isRequired
};
